import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumnWideRemove"><Path d="M2 4V20H13V6H20V11H22V4H2Z" fill="currentColor"/><Path d="M17 13.5858L15.5858 15L17.5858 17L15.5858 19L17 20.4142L19 18.4142L21 20.4142L22.4142 19L20.4142 17L22.4142 15L21 13.5858L19 15.5858L17 13.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideRemove;
